import s from './Footer.module.css';

export function Footer() {
  return (
    <footer className={s.footer}>
      <div className={s.inner}>
        <div className={s.left}>
          <a href="#" className={s.logo}>
            <span className={s.logoBadge}>ME</span>
            <span className={s.logoText}>住縁 Mirai EMS</span>
          </a>
          <span className={s.copyright}>&copy; 2025 Jiayin Inc. All rights reserved.</span>
        </div>
        <div className={s.links}>
          <a href="/terms" className={s.link}>利用規約</a>
          <a href="/privacy" className={s.link}>プライバシーポリシー</a>
          <a href="/tokushoho" className={s.link}>特定商取引法に基づく表記</a>
        </div>
      </div>
    </footer>
  );
}
